import {apollo} from "./graphql";
import {gql} from "@apollo/client";

export function isCellToday(start, end) {
    let dpToday = {
        midnight: DayPilot.Date.today(),
        noon: DayPilot.Date.today().addHours(12)
    };

    return (start === dpToday.midnight || start.getDatePart().addHours(12) === dpToday.noon)
        && (start.getDatePart().addHours(12) === end || start.getDatePart().addHours(24) === end);
}

export function isCellWeekend(dpDate) {
    return dpDate.dayOfWeek() === 6 || dpDate.dayOfWeek() === 0 ? true : false;
}

export function moveRoomBlock(dayPilotArgs) {
    let newRoom = dayPilotArgs.e.data.resource;
    if (dayPilotArgs.hasOwnProperty('newResource')) {
        // room block was moved to another place
        newRoom = parseInt(dayPilotArgs.newResource, 10);
    }

    apollo.mutate({
        mutation: gql`
             mutation UpdateRoomBlock($input:UpdateRoomBlockInput!) {
                 updateRoomBlock(input: $input) {
                     roomBlock {
                         id
                     }
                 }
             }
        `,
        variables: {
            input: {
                id: dayPilotArgs.e.id(),
                roomSetup: newRoom,
                start: dayPilotArgs.newStart.toString('yyyy-MM-dd'),
                end: dayPilotArgs.newEnd.toString('yyyy-MM-dd'),
                title: dayPilotArgs.e.data.text,
            },
        },
    });
}
